import React, { Component } from 'react';
import { Button, message } from 'antd';
import qs from 'qs';
import { fetchData } from '../../../lib/apis';
import OrderListFilters from './components/OrderListFilters';
import OrderListTable from './components/OrderListTable';
import './order-list.css';

function normalizeFilters(raw = {}) {
    const next = { ...raw };
    if (raw.created_range && raw.created_range.length === 2) {
        next.created_from = raw.created_range[0].startOf('day').valueOf();
        next.created_to = raw.created_range[1].endOf('day').valueOf();
    }
    if (raw.confirmed_range && raw.confirmed_range.length === 2) {
        next.confirmed_from = raw.confirmed_range[0].startOf('day').valueOf();
        next.confirmed_to = raw.confirmed_range[1].endOf('day').valueOf();
    }
    delete next.created_range;
    delete next.confirmed_range;
    return next;
}

export default class OrderIndexView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            loading: false,
            total: 0,
            assigneeOptions: []
        };
        this.limit = 20;
        this.page = 1;
        this.formRef = null;
    }

    componentDidMount() {
        this.loadAssigneeOptions();
        this.getListData();
    }

    loadAssigneeOptions = async () => {
        try {
            const response = await fetchData({ url: 'api/v2/staff/list' });
            const data = Array.isArray(response.data) ? response.data : [];
            this.setState({
                assigneeOptions: data.map((item) => ({
                    user_id: `${item.id_user_vnp_sw || item.user_id || ''}`.trim(),
                    name: item.user_name_vnp_sw || item.full_name || item.name || `${item.id_user_vnp_sw || item.user_id || ''}`.trim()
                })).filter((item) => item.user_id)
            });
        } catch (err) {
            this.setState({ assigneeOptions: [] });
        }
    }

    getListData = async () => {
        try {
            this.setState({ loading: true });
            const filterValues = this.formRef ? this.formRef.getFieldsValue() : {};
            const params = {
                page: this.page,
                limit: this.limit,
                ...normalizeFilters(filterValues)
            };
            const response = await fetchData({
                url: `api/v1/orders-v2/list?${qs.stringify(params)}`
            });

            this.setState({
                listData: response.data || [],
                total: response.total || 0,
                loading: false
            });
        } catch (err) {
            this.setState({ loading: false });
            this.props.notification({
                title: 'Đơn hàng',
                content: err.message || 'Không thể tải danh sách đơn hàng',
                type: 'error'
            });
        }
    }

    handleClaimOrder = async (order) => {
        try {
            await fetchData({
                url: `api/v1/orders-v2/${order._id}/assign`,
                method: 'post',
                data: {}
            });
            message.success('Đã nhận xử lý đơn hàng');
            this.getListData();
        } catch (err) {
            this.props.notification({
                title: 'Đơn hàng',
                content: err.message || 'Nhận xử lý thất bại',
                type: 'error'
            });
        }
    }

    render() {
        return (
            <div className="content-m list-h order-list-page">
                <div className="list-c list-m order-list-page__content">
                    <div className="order-list-page__header">
                        <div className="order-list-page__title-group">
                            <span className="order-list-page__eyebrow">Order operations</span>
                            <div className="order-list-page__title-row">
                                <h3 className="order-list-page__title">Đơn hàng</h3>
                                <span className="order-list-page__count">{this.state.total}</span>
                            </div>
                        </div>
                        <Button className="order-list-page__refresh" onClick={this.getListData}>Làm mới</Button>
                    </div>
                    <OrderListFilters
                        formRef={(form) => { this.formRef = form; }}
                        assigneeOptions={this.state.assigneeOptions}
                        onChange={() => {
                            this.page = 1;
                            this.getListData();
                        }}
                        onReset={() => {
                            if (this.formRef) this.formRef.resetFields();
                            this.page = 1;
                            this.getListData();
                        }}
                    />
                    <OrderListTable
                        data={this.state.listData}
                        loading={this.state.loading}
                        page={this.page}
                        limit={this.limit}
                        total={this.state.total}
                        onPageChange={(page, size) => {
                            this.page = page;
                            this.limit = size || this.limit;
                            this.getListData();
                        }}
                        onOpenDetail={(item) => this.props.history.push(`/order/${item._id}`)}
                        onClaimOrder={this.handleClaimOrder}
                    />
                </div>
            </div>
        );
    }
}
